import { render, staticRenderFns } from "./action.vue?vue&type=template&id=3f903b4a&scoped=true&"
import script from "./action.vue?vue&type=script&lang=js&"
export * from "./action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f903b4a",
  null
  
)

export default component.exports